import DataTransmissionTableRecord from "./DataTransmissionTableRecord";
const DataTransmissionTable = ({ data, min }) => {
    return (
        <div className="data-transmission-table-container">
            <table>
                <colgroup>
                    <col style={{width: "75%"}}/>
                    <col style={{width: "5%"}}/>
                    <col style={{width: "20%"}}/>
                </colgroup>
                <tbody>
                    <tr style={{fontWeight: "bold"}}>
                        <th>FlowMeter</th>
                        <th>State</th>
                        <th>Date</th>
                    </tr>
                    {data && data.map((record) => {
                        return <DataTransmissionTableRecord
                            key={record.flowMeterName}
                            flowMeterName={record.flowMeterName}
                            date={record.last_availability}
                            min={min}
                        />
                    })}
                </tbody>
            </table>
        </div>
    )
}
export default DataTransmissionTable;